"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardBody = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ContactCardBody = (0, _styled.default)("span")`
    align-self: center;
    flex: 1 1 auto;

    // Set a fixed width here so the child elements can inherit it and use it in their own
    // max-width for overflow: hidden + elide to work.
    min-width: 1px;

    // This is needed to make sure the child elements don't overflow the parent. We cannot just set
    // overflow: hidden on the parent because that would hide the action button as well which is
    // positioned w/ a negative left margin so the text lines up nicely.
    & > * {
        max-width: 100%;
        overflow: hidden;
    }
`;
exports.ContactCardBody = ContactCardBody;
//# sourceMappingURL=ContactCardBody.js.map